import { uiBase } from '../env/constants'

export const userURL = uiBase +'user'
